import type { BdrLeadFormProps } from "./types"
import { useBdrLeadFormCompany } from "./useBdrLeadFormCompany"
import { BdrLeadFormEssentials } from "./BdrLeadFormEssentials"
import { BdrLeadFormExtended } from "./BdrLeadFormExtended"

export type { BdrNewLead, BdrLeadFormProps } from "./types"

export function BdrLeadForm({ newLead, setNewLead, backendErrors, mode }: BdrLeadFormProps) {
  const company = useBdrLeadFormCompany(newLead, setNewLead)
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <BdrLeadFormEssentials newLead={newLead} setNewLead={setNewLead} backendErrors={backendErrors} mode={mode} company={company} />
      <BdrLeadFormExtended newLead={newLead} setNewLead={setNewLead} backendErrors={backendErrors} mode={mode} company={company} />
    </div>
  )
}
